import { mergeConfig } from './config.base';

export const config = mergeConfig({
  CLIENT_ID: '27ef75ca-914d-4f86-b49c-deab3352b07b',
  AUTH_URL: 'https://identity-staging.inflosoftware.com',
  ENVIRONMENTS: [{ name: 'Staging', url: 'https://staging.inflosoftware.com/' }],
});
